import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Pagination } from 'src/app/core/models/pagination.model';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-company-filter',
  templateUrl: './company-filter.component.html',
  styleUrls: ['./company-filter.component.css'],
  host: { 'class': 'navbar navbar-default bg-master-lighter sm-padding-10 full-width p-t-0 p-b-0' }
})
export class CompanyFilterComponent {

  @Input()
  pagination: Pagination;
  searchBox = new FormControl();
  activeSwitch = 'active';

  @Output()
  onSearch = new EventEmitter<string>();

  @Output()
  onActiveFilter = new EventEmitter<string>();

  get allItems() {
    return this.pagination.totalItems;
  }

  constructor() {
    this.searchBox
      .valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe(term => {
        this.onSearch.emit(term);
      });
  }

  activeFilterChange(activeFilter: string) {
    this.activeSwitch = activeFilter;
    this.onActiveFilter.emit(activeFilter);
  }

}
